import React, { useEffect, useRef, useState } from 'react';
import { SearchAddressForm } from '../../organisms/SearchStore/AU/Presentation/SearchAddressForm';
import DELIVERY_ADDRESS_SEARCH_FORM_CONSTANTS from 'organisms/DeliveryAddressSearchForm/Constants/DeliveryAddressSearchFormConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import PropTypes from 'prop-types';

/**
 * PostalCodeFormComponent - A component that creates input to search postal code in the format 'NNN-NNNN'
 * @param props - verifyPostalCode {Function}
 * @returns {JSX.Element}
 * @constructor
 */
const PostalCodeFormComponent = props => {
  const { defaultPostalValue, verifyPostalCode } = props;
  const [postalCode, setPostalCode] = useState(defaultPostalValue);
  const inputRef = useRef(null);
  const POSTAL_CODE_LENGTH = 8; //Sets max length to be 8

  useEffect(() => {
    if (defaultPostalValue) {
      setPostalCode(defaultPostalValue);
    }
  }, [defaultPostalValue]);

  useEffect(() => {
    inputRef?.current?.focus();
  }, []);

  /**
   * inputOnChangePostalCode - event triggered on change of a input
   * @param value{string} - input which has numeric values to entered with format "NNN-NNNN"
   */
  const inputOnChangePostalCode = value => {
    // Remove any non-digit characters from the value
    let formattedValue = value.replace(/[^\d ]+/g, '');
    // Append hyphen(-) after  three-digit characters from the value
    formattedValue = formattedValue.length > 3 ? formattedValue.replace(/(.{3})/, '$1-') : formattedValue;
    const isPostalCodeValid = formattedValue.length >= POSTAL_CODE_LENGTH;
    setPostalCode(formattedValue);
    verifyPostalCode(isPostalCodeValid, formattedValue);
  };

  /**
   * onClearTextHandler - callback to be called when the clear search option in the postal input is clicked
   */
  const onClearTextHandler = () => {
    verifyPostalCode(false, '');
    setPostalCode('');
  };

  return (
    <div className='delivery-address-section search-store-postal-content'>
      <SearchAddressForm
        maxLength={POSTAL_CODE_LENGTH}
        onClearTextHandler={onClearTextHandler}
        placeholder={translateWithI18Next(DELIVERY_ADDRESS_SEARCH_FORM_CONSTANTS.SEARCH)}
        address={postalCode}
        inputOnChange={inputOnChangePostalCode}
        inputRef={inputRef}
      />
    </div>
  );
};

PostalCodeFormComponent.defaultProps = {
  defaultPostalValue: '',
  verifyPostalCode: () => null,
};

PostalCodeFormComponent.propTypes = {
  defaultPostalValue: PropTypes.string,
  verifyPostalCode: PropTypes.func,
};
export default PostalCodeFormComponent;
